import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with show/hide eye toggle.
 * Passes through all other props (value, onChange, placeholder, autoComplete, etc.).
 * The `testId` prop is applied to the input; the toggle button uses `${testId}-toggle`.
 */
export default function PasswordInput({ testId = "password-input", className = "", ...rest }) {
  const [show, setShow] = useState(false);
  return (
    <div className={`relative ${className}`}>
      <input
        {...rest}
        type={show ? "text" : "password"}
        data-testid={testId}
        className="input pr-11"
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        data-testid={`${testId}-toggle`}
        aria-label={show ? "Hide password" : "Show password"}
        tabIndex={-1}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-[#8A9488] hover:text-[#2D332D] focus:outline-none focus:text-[#2D332D]"
      >
        {show ? <EyeOff size={17} strokeWidth={1.6} /> : <Eye size={17} strokeWidth={1.6} />}
      </button>
    </div>
  );
}
